import { z } from 'zod';

export const CakeToOrderSetModelSchema = z.object({
    name: z.string(),
    elements: z.array(
        z.object({
            name: z.string(),
            meassure: z.string(),
            value: z.number(),
        }),
    ).optional().nullable(),
});

export type CakeToOrderSetModel = z.infer<typeof CakeToOrderSetModelSchema>;
